/* ==========================================================================
   Ajiaco y Frijoles — Horario
   Calcula abierto/cerrado en la zona horaria del restaurante y actualiza
   todos los indicadores de la página cada minuto.
   ========================================================================== */
(function () {
  'use strict';

  var DAY_KEYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
  var DAY_NAMES = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

  function readSchedule() {
    var node = document.getElementById('ayf-schedule');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  function toMinutes(value) {
    var parts = String(value || '').split(':');
    var hours = parseInt(parts[0], 10);
    var minutes = parseInt(parts[1], 10);
    if (isNaN(hours)) return null;
    return hours * 60 + (isNaN(minutes) ? 0 : minutes);
  }

  function localNow(timeZone) {
    try {
      var formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: timeZone || 'America/Bogota',
        weekday: 'short',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      });
      var parts = {};
      formatter.formatToParts(new Date()).forEach(function (part) {
        parts[part.type] = part.value;
      });
      var weekdayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
      return {
        day: weekdayMap[parts.weekday],
        minutes: parseInt(parts.hour, 10) * 60 + parseInt(parts.minute, 10)
      };
    } catch (e) {
      var fallback = new Date();
      return { day: fallback.getDay(), minutes: fallback.getHours() * 60 + fallback.getMinutes() };
    }
  }

  function formatTime(value) {
    var minutes = toMinutes(value);
    if (minutes == null) return value;
    var hours = Math.floor(minutes / 60);
    var rest = minutes % 60;
    var suffix = hours >= 12 ? 'PM' : 'AM';
    var display = hours % 12 === 0 ? 12 : hours % 12;
    return display + ':' + (rest < 10 ? '0' + rest : rest) + ' ' + suffix;
  }

  function evaluate(schedule) {
    var now = localNow(schedule.timezone);
    var today = schedule.days[DAY_KEYS[now.day]];

    if (today && today.open && today.close) {
      var open = toMinutes(today.open);
      var close = toMinutes(today.close);
      if (now.minutes >= open && now.minutes < close) {
        return { open: true, closesAt: formatTime(today.close), nextOpening: null };
      }
      if (now.minutes < open) {
        return { open: false, nextOpening: 'las ' + formatTime(today.open), nextDay: 'hoy' };
      }
    }

    for (var offset = 1; offset <= 7; offset++) {
      var index = (now.day + offset) % 7;
      var day = schedule.days[DAY_KEYS[index]];
      if (day && day.open && day.close) {
        return {
          open: false,
          nextOpening: 'las ' + formatTime(day.open),
          nextDay: offset === 1 ? 'mañana' : 'el ' + DAY_NAMES[index]
        };
      }
    }

    return { open: false, nextOpening: null, nextDay: null };
  }

  function render(status, schedule) {
    document.querySelectorAll('[data-ayf-status]').forEach(function (node) {
      var label = node.querySelector('[data-ayf-status-label]') || node;
      node.setAttribute('data-open', status.open ? 'true' : 'false');

      if (status.open) {
        label.textContent = (node.dataset.openLabel || 'Abierto ahora') +
          (status.closesAt && node.dataset.showClose === 'true' ? ' · hasta ' + status.closesAt : '');
      } else if (status.nextOpening) {
        var closedTemplate = node.dataset.closedLabel || 'Cerrado · recibimos tu pedido a partir de {time}';
        label.textContent = closedTemplate
          .replace('{time}', status.nextOpening)
          .replace('{day}', status.nextDay || '');
      } else {
        label.textContent = node.dataset.closedLabel || 'Cerrado';
      }
    });

    if (window.AYF) {
      window.AYF.setSchedule({
        open: status.open,
        nextOpening: [status.nextDay, status.nextOpening].filter(Boolean).join(' '),
        timezone: schedule.timezone
      });
    }
  }

  function start() {
    var schedule = readSchedule();
    if (!schedule) return;

    var tick = function () {
      render(evaluate(schedule), schedule);
    };

    tick();
    window.setInterval(tick, 60000);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) tick();
    });
    document.addEventListener('shopify:section:load', tick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
